<template>
  <v-form v-model="valid">
    <v-dialog max-width="600px" persistent v-model="dialog.show">
      <v-card>
        <v-card-title>
          <span class="headline">商品の追加</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex md12 sm12 xs12>
                <query-autocomplete
                  item-text="code"
                  item-value="code"
                  label="商品検索"
                  return-object
                  url="skus?code={term}"
                  v-model="code"
                />
              </v-flex>
              <v-flex md6 sm6 xs6>
                <div required style="display:flex;">
                  <v-text-field
                    :rules="[v => !!v || '商品 is required']"
                    clearable
                    label="商品"
                    v-model="form.skuCode"
                  />
                </div>
              </v-flex>
              <v-flex md6 sm6 xs6>
                <div required style="dispaly:flex;">
                  <v-text-field
                    :rules="[v => !!v || '単価 is required']"
                    clearable
                    label="FOB単価"
                    type="number"
                    v-model.number="form.unitPrice"
                  />
                </div>
              </v-flex>
              <v-flex md6 sm6 xs6>
                <div required style="display:flex;">
                  <remote-autocomplete
                    :rules="[v => !!v || '通貨 is required']"
                    @item="(item)=>currency=item"
                    item-text="iso3code"
                    item-value="code"
                    label="通貨"
                    url="currencies/all"
                    v-model="form.currencyCode"
                  />
                </div>
              </v-flex>
              <v-flex md6 sm6 xs6>
                <div required style="display:flex;">
                  <v-text-field
                    :rules="[v => !!v || '輸入数 is required']"
                    clearable
                    label="輸入数"
                    type="number"
                    v-model.number="form.qty"
                  />
                </div>
              </v-flex>
              <v-flex md6 sm6 xs6>
                <div required style="display:flex;">
                  <v-text-field
                    :rules="[v => !!v || '入り数 is required']"
                    clearable
                    label="入り数"
                    type="number"
                    v-model.number="form.perCartonQty"
                  />
                </div>
              </v-flex>
              <v-flex md6 sm6 xs6>
                <div required style="display:flex;">
                  <v-text-field
                    :rules="[v => !!v || 'G/W is required']"
                    clearable
                    label="G/W(kg)"
                    type="number"
                    @change="form.perCartonGrossWeight=$numberScale2(form.perCartonGrossWeight)"
                    v-model="form.perCartonGrossWeight"
                  />
                </div>
              </v-flex>
              <v-flex md6 sm6 xs6>
                <div required style="display:flex;">
                  <v-text-field
                    :rules="[v => !!v || '縦寸法 is required']"
                    clearable
                    label="縦寸法(cm)"
                    type="number"
                    v-model.number="form.cartonWidth"
                  />
                </div>
              </v-flex>
              <v-flex md6 sm6 xs6>
                <div required style="display:flex;">
                  <v-text-field
                    :rules="[v => !!v || '横寸法 is required']"
                    clearable
                    label="横寸法(cm)"
                    type="number"
                    v-model.number="form.cartonLength"
                  />
                </div>
              </v-flex>
              <v-flex md6 sm6 xs6>
                <div required style="display:flex;">
                  <v-text-field
                    :rules="[v => !!v || '高さ is required']"
                    clearable
                    label="高さ(cm)"
                    type="number"
                    v-model.number="form.cartonHeight"
                  />
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="!valid" @click="submit" color="success">確定</v-btn>
          <v-btn @click="dialog.show=false" color="red">{{$t('app.buttons.back')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-form>
</template>

<script>
export default {
  props: ["dialog"],
  data() {
    return {
      valid: false,
      form: {},
      code: null,
      currency: null
    };
  },
  watch: {
    code(data) {
      this.form = {
        ...this.form,
        skuCode: data.code,
        unitPrice: data.unitPrice,
        currencyCode: data.unitPriceCurrencyCode,
        perCartonQty: data.boxQty,
        perCartonGrossWeight: data.boxWeight,
        cartonWidth: data.boxWidth,
        cartonLength: data.boxLength,
        cartonHeight: data.boxHeight
      };
    }
  },
  methods: {
    submit() {
      this.$http
        .post(`skus/createIfNotExists`, {
          code: this.form.skuCode,
          unitPrice: this.form.unitPrice,
          unitPriceCurrencyCode: this.form.currencyCode,
          boxQty: this.form.perCartonQty,
          boxWeight: this.form.perCartonGrossWeight,
          boxWidth: this.form.cartonWidth,
          boxLength: this.form.cartonLength,
          boxHeight: this.form.cartonHeight
        })
        .then(() => {
          this.form.currencyRate =
            this.currency &&
            this.$getCurrencyRate(
              this.currency,
              "INTERNAL",
              new Date().format("yyyy-MM-dd")
            );
          this.form.subTotal = this.form.qty * this.form.unitPrice;
          this.$emit("submit", this.form);
          this.form = { ...this.form };
        });
    }
  }
};
</script>